import { render, staticRenderFns } from "./banben.vue?vue&type=template&id=61665700&scoped=true"
import script from "./banben.vue?vue&type=script&lang=js"
export * from "./banben.vue?vue&type=script&lang=js"
import style0 from "./banben.vue?vue&type=style&index=0&id=61665700&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61665700",
  null
  
)

export default component.exports